import React from 'react';
import { Button } from '@economic/taco';
import { t } from '../../../../shared/components/l10n/l10n';
import DialogFooter from './ModalFooter';

interface Props {
    onDone: () => void;
}

export default function StepConfirmStart({ onDone }: Props) {
    return (
        <>
            <div className="moneyflow__onboarding moneyflow__onboarding__content moneyflow__onboarding__start">
                <h1>{t`MONEYFLOW_ONBOARDING_CONFIRM_HEADER`}</h1>
                <p className="whitespace-pre-wrap">
                    {t`MONEYFLOW_ONBOARDING_CONFIRM_TEXT1`} <strong>{t`MONEYFLOW_ONBOARDING_CONFIRM_SHAREDDATA`}</strong>
                </p>

                <p className="whitespace-pre-wrap">{t`MONEYFLOW_ONBOARDING_CONFIRM_TEXT2`}</p>
                <div className="pt-4 text-center">
                    <Button appearance="primary" onClick={() => onDone()} autoFocus>
                        {t`MONEYFLOW_ONBOARDING_CONFIRM_START_BUTTON`}
                    </Button>
                    <h4 className="moneyflow__onboarding__start__free">{t`MONEYFLOW_ONBOARDING_CONFIRM_FREE`}</h4>
                </div>
            </div>

            <DialogFooter />
        </>
    );
}
